import axiosInstance from "../../../Axios/Axios"

const getAll=async({queryKey}:any)=>{
    //let tenantId=queryKey[1];
return await axiosInstance.get(`Index/GetAll?pageIndex=1&pageSize=50000`)
}

const getAllCategory=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
return await axiosInstance.get(`Index/GetAllCategoriesTenantId?tenantId=${tenantId}&pageIndex=1&pageSize=50000`)
}

const getBank=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
return await axiosInstance.get(`Index/GetBank?tenantId=${tenantId}`)
}

const addIndex=async(Data:any)=>{
return await axiosInstance.post('/Index/AddIndex',Data)
}

const editIndex=async(Data:any)=>{
    return await axiosInstance.post('/Index/EditIndex',Data)
}

const getAllCategoriesTenantId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    return await axiosInstance.get(`/Index/GetAllCategoriesTenantId?tenantId=${tenantId}&pageIndex=1&pageSize=50000`)
}

const addCategory=async(Data:any)=>{
    return await axiosInstance.post('/Index/AddCategory',Data)
}

const editCategory=async(Data:any)=>{
    return await axiosInstance.post('/Index/EditCategory',Data)
}

// const getIndexDetail=async(Data:any)=>{
//     return await axiosInstance.post('/Index/GetIndexDetail',Data)
// }

const getIndexDetail=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
return await axiosInstance.get(`Index/GetIndexDetail?id=${tenantId}`)
}

const deleteCategory=async(Data:any)=>{
    return await axiosInstance.post('/Index/DeleteCategory',Data)
}

const deleteIndex=async(Data:any)=>{
    return await axiosInstance.post('/Index/Delete',Data)
}

const acceptIndex=async(Data:any)=>{
    return await axiosInstance.post('/Index/AcceptIndex',Data)
}

export {
    getAll,
    getAllCategoriesTenantId,
    addIndex,
    getIndexDetail,
    editIndex,
    deleteCategory,
    getAllCategory,
    addCategory,
    getBank,
    editCategory,
    acceptIndex,
    deleteIndex
}